import { render } from "./TasksComponent.vue?vue&type=template&id=095e8e75"
import script from "./TasksComponent.vue?vue&type=script&lang=js"
export * from "./TasksComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__